import { render } from "./WordBook.vue?vue&type=template&id=e51f1230&scoped=true"
const script = {}

import "./WordBook.vue?vue&type=style&index=0&id=e51f1230&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e51f1230"]])

export default __exports__